var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_1688)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2932 15.707C11.4807 15.8944 11.735 15.9998 12.0002 15.9998C12.2653 15.9998 12.5197 15.8944 12.7072 15.707L18.3642 10.05C18.4597 9.95773 18.5359 9.84739 18.5883 9.72538C18.6407 9.60338 18.6683 9.47216 18.6694 9.33938C18.6706 9.2066 18.6453 9.07492 18.595 8.95202C18.5447 8.82913 18.4705 8.71747 18.3766 8.62358C18.2827 8.52969 18.171 8.45544 18.0481 8.40515C17.9252 8.35487 17.7936 8.32957 17.6608 8.33073C17.528 8.33188 17.3968 8.35947 17.2748 8.41188C17.1528 8.46428 17.0424 8.54047 16.9502 8.63598L12.0002 13.586L7.05018 8.63598C6.86158 8.45382 6.60898 8.35302 6.34678 8.3553C6.08458 8.35758 5.83377 8.46275 5.64836 8.64816C5.46295 8.83357 5.35778 9.08438 5.35551 9.34658C5.35323 9.60877 5.45402 9.86137 5.63618 10.05L11.2932 15.707Z",
    fill: "#3B755E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_1688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#3B755E",
    transform: "matrix(0 1 1 0 0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.9faff6936e88b8a51d8de570176abbd5.svg";
export { ForwardRef as ReactComponent };